import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ImageDataDb } from '../_shared/data/image-data-db.data';
import { IDynamicElement, ImageData, MediaImage } from '../_shared/models';
import { IQuote } from '../_shared/models/quote.model';
import { GridComponent } from '../grid/grid.component';
import { ImageItemComponent } from '../media/media-item/image-item/image-item.component';

@Component({
    selector: 'sirius-quote',
    templateUrl: './quote.component.html',
    styleUrls: ['./quote.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    // The quote body is injected HTML, so the closing quotation mark has to be
    // placed on a paragraph this component does not own. Emulated encapsulation
    // cannot reach those nodes, so styles are unscoped and namespaced under the
    // host class instead - the same approach `sirius-text-html` uses.
    encapsulation: ViewEncapsulation.None,
    host: {
        'class': 'sir-quote',
    },
    imports: [GridComponent, ImageItemComponent, CommonModule]
})
export class QuoteComponent implements OnInit, IDynamicElement {
    @Input() textHtml = '';
    @Input() authorHtml = '';
    @Input() image?: MediaImage;

    config?: IQuote;
    imageData?: ImageData;

    ngOnInit(): void {
        if (this.config) {
            this.textHtml = this.config.textHtml;
            this.authorHtml = this.config.cite; // should be citeHtml from backend
            this.image = this.config.image;
        }

        this.imageData = ImageDataDb.quote;
    }
}
